var _path, _circle, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHide = function SvgHide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 19",
    fill: "#020710",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.8 5C5.203 5 2.008 6.964 0 10c2.007 3.036 5.202 5 8.8 5 3.6 0 6.795-1.964 8.802-5C15.595 6.964 12.4 5 8.8 5Zm.2 9a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 10,
    r: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m6.516 16.455-.116.447.436.151 1.21.42.512.177.136-.524 3.79-14.581.116-.447-.436-.151-1.21-.42-.512-.177-.136.524-3.79 14.581Z",
    stroke: "#fff"
  })));
};

export default SvgHide;